module.exports = __webpack_public_path__ + "static/symbol-white-transparent-c072252e8d96e36b803141083de017fb.png";